import { useState } from "react";
import { useRole } from "@/contexts/RoleContext";
import { MobileTutorProgress } from "./MobileTutorProgress";
import { MobileTutorProfile } from "./MobileTutorProfile";
import { LayoutGrid, User } from "lucide-react";
import lurneaxLogo from "@/assets/lurneax-logo.svg";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

type Tab = "progress" | "profile";

export function MobileTutorShell() {
  const [activeTab, setActiveTab] = useState<Tab>("progress");
  const { userProfile } = useRole();

  const initials =
    userProfile?.full_name
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2) || "T";

  return (
    <div className="flex flex-col min-h-[100dvh] overflow-x-hidden max-w-full" style={{ background: "#FAF7F3", fontFamily: "-apple-system, system-ui, sans-serif" }}>
      {/* Top Nav */}
      <header className="sticky top-0 z-50 flex items-center justify-between px-4 h-12" style={{ background: "#FAF7F3" }}>
        <img src={lurneaxLogo} alt="Lurneax" className="h-7 w-7" />
        <div className="flex items-center gap-2 rounded-full px-2 py-1" style={{ background: "#ffffff", border: "0.5px solid #e8e0d8" }}>
          <Avatar className="h-7 w-7">
            <AvatarImage src={userProfile?.avatar_url || undefined} />
            <AvatarFallback className="text-[10px] font-semibold" style={{ background: "#F2C9C0", color: "#C03010" }}>
              {initials}
            </AvatarFallback>
          </Avatar>
          <span className="text-xs font-medium pr-1" style={{ color: "#1B2D5B" }}>
            {userProfile?.full_name?.split(" ")[0] || "Tutor"}
          </span>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 overflow-y-auto px-4 pb-24">
        {activeTab === "progress" ? <MobileTutorProgress /> : <MobileTutorProfile />}
      </main>

      {/* Bottom Nav */}
      <nav className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-around h-16 safe-area-bottom" style={{ background: "#ffffff", borderTop: "0.5px solid #e8e0d8" }}>
        <button
          onClick={() => setActiveTab("progress")}
          className="flex flex-col items-center justify-center flex-1 h-full gap-1"
          style={{ color: activeTab === "progress" ? "#F44321" : "#9a8a7a" }}
        >
          <LayoutGrid className="h-5 w-5" />
          <span className="text-[10px] font-semibold">Progress</span>
        </button>
        <button
          onClick={() => setActiveTab("profile")}
          className="flex flex-col items-center justify-center flex-1 h-full gap-1"
          style={{ color: activeTab === "profile" ? "#F44321" : "#9a8a7a" }}
        >
          <User className="h-5 w-5" />
          <span className="text-[10px] font-semibold">Profile</span>
        </button>
      </nav>
    </div>
  );
}